import React, { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useMutation } from '@apollo/client';
import { CREATE_BILLING_PORTAL_SESSION } from '~/services';
import { useLayoutContext } from '~/components/layout/Layout';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const ActiveSubscription = ({ t, agentId, subscription, product }: any) => {
  const { i18n } = useTranslation();
  // Map values from subscription and product
  const [loading, setLoading] = useState(false);
  const [createBillingPortalSession] = useMutation(
    CREATE_BILLING_PORTAL_SESSION,
  );
  const { renderToast } = useLayoutContext();
  // Handle demo subscriptions which don't have associated products
  const planName =
    product?.name || (subscription?.message_limit ? 'Demo' : '-');
  const messages =
    product?.metadata?.messages ||
    product?.metadata?.['messages '] ||
    subscription?.message_limit ||
    '-';

  // Get renewal date from the new subscription structure
  const renewalDate =
    subscription?.stripe_data?.current_period_end || subscription?.period_end
      ? moment(
          subscription?.stripe_data?.current_period_end ||
            subscription?.period_end,
        )
          .locale(i18n.language)
          .format('D MMMM YYYY')
      : '-';

  const handleCreateBillingPortalSession = async () => {
    setLoading(true);
    const { data } = await createBillingPortalSession({
      variables: { data: { agent_id: agentId } },
    });
    if (data.create_billing_portal_session.hasError) {
      renderToast({
        message: data.create_billing_portal_session.message,
        type: 'error',
      });
    } else {
      window.location.href = data.create_billing_portal_session.data.url;
    }
    setLoading(false);
  };

  return (
    <div className="flex flex-col justify-center gap-4 md:justify-start md:gap-16">
      {/* Stat style summary */}
      <div className="stats mb-6 flex flex-col gap-4 shadow md:flex-row md:gap-0">
        <div className="stat">
          <div className="stat-title">{t('current_plan', 'Current Plan')}</div>
          <div className="stat-value">{planName}</div>
          <div className="stat-desc">
            {t('messages_included', {
              count: messages,
            })}
          </div>
        </div>
        <div className="stat">
          <div className="stat-title">{t('next_renewal', 'Next Renewal')}</div>
          <div className="stat-value">{renewalDate}</div>
        </div>
      </div>
      {/* Only show manage subscription button for paid subscriptions */}
      {subscription?.stripe_data?.customer_id && (
        <>
          {loading ? (
            <div className="mt-6 flex justify-end">
              <Skeleton width={200} height={32} />
            </div>
          ) : (
            <div className="mt-6 flex justify-end">
              <button
                className="btn btn-primary rounded-full"
                onClick={handleCreateBillingPortalSession}
              >
                {t('manage_subscription_button', 'Manage Subscription')}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ActiveSubscription;
